export class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      if (this.input.form) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      }
      this.input.addEventListener(
        'input',
        theme.utils.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
if (!customElements.get('search-form')) customElements.define('search-form', SearchForm);
/*
 * Prefix / partial-word search via the "*" wildcard.
 *
 * Shopify's options[prefix]=last does NOT prefix-match real dictionary words
 * (e.g. "hedge" will not find "Hedgehog Tales" — verified on both the full
 * search and predictive endpoints). Appending "*" to the last term does work
 * ("hedge*" -> "Hedgehog Tales"), so on submit we wildcard the final term for
 * every search form (covers both <search-form> and <predictive-search>).
 * Predictive/autocomplete does the same in predictive-search.js. The trailing
 * "*" is stripped from the visible input on the results page so the box reads
 * cleanly, and re-applied if the shopper searches again.
 */
(function () {
  const isSearchForm = (form) =>
    form instanceof HTMLFormElement &&
    (form.getAttribute('role') === 'search' || (form.getAttribute('action') || '').includes('/search'));

  const wildcardLastTerm = (value) => value.trim().replace(/(\S+)\s*$/, '$1*');

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!isSearchForm(form)) return;
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      const q = input.value.trim();
      if (!q || q.endsWith('*')) return;
      input.value = wildcardLastTerm(q);
    },
    true
  );

  const stripWildcardForDisplay = () => {
    if (!document.body || !document.body.classList.contains('template-search')) return;
    document
      .querySelectorAll('form[role="search"] input[name="q"], form[action*="/search"] input[name="q"]')
      .forEach((input) => {
        if (input.value.endsWith('*')) input.value = input.value.replace(/\*+\s*$/, '');
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripWildcardForDisplay, { once: true });
  } else {
    stripWildcardForDisplay();
  }
})();
